import { ApplicationStatus } from 'enums/ApplicationStatus';
import { DashboardStep } from 'enums/DashboardStep';

export const STATUSES_AS_PROCESSING = [
  ApplicationStatus.Purgatory,
  ApplicationStatus.Processing,
  ApplicationStatus.Compliance,
  ApplicationStatus.ReadyToSubmit,
  ApplicationStatus.Underwriting,
  ApplicationStatus.NeedMoreInfo,
  ApplicationStatus.NMICompleted,
  ApplicationStatus.PendingFunding,
  ApplicationStatus.Approved,
];
export const STATUSES_FOR_WITHDRAW_APPLICATION = [
  ApplicationStatus.Purgatory,
  ApplicationStatus.Processing,
  ApplicationStatus.Compliance,
  ApplicationStatus.ReadyToSubmit,
];
export const WITHDRAW_APPLICATION = 'Withdraw Application';
export const DISABLED_FUNDING_TOOLTIP_TEXT = 'Complete ID upload to access Funding';
export const DASHBOARD_STEPS_WITH_UPLOADING_DOCUMENTS = [
  DashboardStep.BorrowerInformation,
  DashboardStep.CoBorrowerInformation,
  DashboardStep.FundingInformation,
  DashboardStep.HomeOwnership,
  DashboardStep.ContractorWorkOrder,
];
export const STATUSES_FOR_LOAN_DETAILS = [
  ApplicationStatus.Purgatory,
  ApplicationStatus.Processing,
  ApplicationStatus.Compliance,
  ApplicationStatus.ReadyToSubmit,
  ApplicationStatus.Underwriting,
  ApplicationStatus.NeedMoreInfo,
  ApplicationStatus.NMICompleted,
  ApplicationStatus.PendingFunding,
];
